import React from 'react';
import { Link } from 'react-router-dom';
import type { Category } from '../lib/api';

type Props = {
    category: Category;
    productCount?: number;
};

const CategoryCard: React.FC<Props> = ({ category, productCount }) => {
    return (
        <Link className="category-card" to={`/category/${category.slug}`}>
            {category.imageUrl ? (
                <img src={category.imageUrl} alt={category.title} />
            ) : (
                <div className="image-placeholder" aria-hidden="true" />
            )}
            <h3>{category.title}</h3>
            <p className="card-desc">{category.description}</p>
            {productCount !== undefined && productCount > 0 && (
                <p className="category-count">{productCount} prodott{productCount === 1 ? 'o' : 'i'}</p>
            )}
        </Link>
    );
};

export default CategoryCard;
